<div class="account-form-wrapper">
  <div class="registration-process step-0" *ngIf="!hideVerificationProcess">
    <div class="inner-fields">

      <div class="item-fields">
        <div class="send-verification-box m-t-xl">
          <form #form="ngForm" [formGroup]="sendVerificationCodeFG" (ngSubmit)="onSendSignupVerificationCodes(form)"
            class="form create-account" novalidate>
            <!--            <div class="form-group" [hidden]="!sendVerificationCodeFG?.get('nic').value">-->
            <!--              <label class="hidden-label"-->
            <!--                >NIC Number <a class="btn-link chg-ext" (click)="changeNic()"> <i class="icon icon-pencil-3"></i> Change</a></label-->
            <!--              >-->
            <!--              <input-->
            <!--                formControlName="nic"-->
            <!--                type="text"-->
            <!--                class="form-control text-uppercase"-->
            <!--                placeholder="Your NIC"-->
            <!--                disabled="true"-->
            <!--                tabindex="1"-->
            <!--              />-->
            <!--            </div>-->
            <!--            <div class="form-group" [hidden]="!sendVerificationCodeFG?.get('passport').value">-->
            <!--              <label class="hidden-label"-->
            <!--                >Passport Number <a class="btn-link chg-ext" (click)="changeNic()"> <i class="icon icon-pencil-3"></i> Change</a></label-->
            <!--              >-->
            <!--              <input formControlName="passport" type="text" class="form-control" placeholder="Your Passport" disabled="true" />-->
            <!--            </div>-->

            <form-mobile-no [controls]="[
                sendVerificationCodeFG.get('mobilePhoneCountryCode'),
                sendVerificationCodeFG.get('mobilePhoneAreaCode'),
                sendVerificationCodeFG.get('mobilePhoneNumber')
              ]" help="" [showErrors]="form.submitted">
              <span [hidden]="!sendVerificationCodeFG.get('mobilePhoneAreaCode').errors?.required"> {{ translate.currentLang === 'en' ? 'Number Required' : 'নম্বর আবশ্যক' }}
              </span>
              <span [hidden]="
                  !sendVerificationCodeFG.get('mobilePhoneNumber').errors?.requireIfTrue &&
                  !sendVerificationCodeFG.get('mobilePhoneNumber').errors?.pattern
                ">
                {{ translate.currentLang === 'en' ? 'Number must be 10 or 11 digits.' : 'নম্বর অবশ্যই 10 বা 11 সংখ্যার হতে হবে।' }}
              </span>
            </form-mobile-no>

            <div class="form-group mt-2"
              [class.has-error]="form.submitted && sendVerificationCodeFG.controls['email'].invalid && sendVerificationCodeFG.controls.email.touched">
              <!-- <label class="hidden-label">Your Email</label> -->
              <input formControlName="email" type="text" class="form-control" [placeholder]="translate.currentLang === 'en' ? 'Enter your email address' : 'আপনার ইমেইল ঠিকানা লিখুন'"
                tabindex="5" />
              <div class="error-message" *ngIf="
                  form.submitted && sendVerificationCodeFG.controls['email'].invalid && sendVerificationCodeFG.controls.email.touched
                ">
                <span [hidden]="!sendVerificationCodeFG.controls.email.errors?.email">{{ translate.currentLang === 'en' ? 'Email is invalid.' : 'ইমেইল অবৈধ।' }}</span>
                <span [hidden]="!sendVerificationCodeFG.controls.email.errors?.required">{{ translate.currentLang === 'en' ? 'Email is Required' : 'ইমেইল আবশ্যক' }}</span>
              </div>
            </div>
            <!-- <div [hidden]="!signUpFormErrors" class="alert alert-danger">
            <span>Please Enter Mobile Number or Email to send verification code</span>
          </div> -->
            <p *ngIf="sentVerification" [slide]="sentVerification" class="precaution-msg alert alert-info">
              {{ translate.currentLang === 'en' ? 'If you do not receive your code via SMS or email, please contact us via email to' : 'আপনি যদি SMS বা ইমেইলের মাধ্যমে আপনার কোড না পান, অনুগ্রহ করে আমাদের ইমেইলে যোগাযোগ করুন' }}
              <a href="mailto:info&#64;calbd.com.bd">info&#64;calbd.com.bd</a>.
            </p>
            <div class="form-errors alert alert-danger"
              [hidden]="!sendVerificationCodeErrors || !sendVerificationCodeErrors.length">
              <ul>
                <li class="text-left" *ngFor="let error of sendVerificationCodeErrors">
                  {{ error }}
                </li>
              </ul>
            </div>

            <div class="row button-row" [hidden]="sendVerificationCodeErrors && sendVerificationCodeErrors.length > 0">
              <app-primary-button [text]="(sentVerification && (translate.currentLang === 'en' ? 'Resend Reset Code' : 'রিসেট কোড পুনরায় পাঠান')) || (translate.currentLang === 'en' ? 'Send Reset Code' : 'রিসেট কোড পাঠান')"
                [loading]="sentVeryficationInProgress" type="submit" [fullWidth]="true">
              </app-primary-button>
            </div>
          </form>
          <form #vform="ngForm" [formGroup]="verifySignupFG" [hidden]="!sentVerification"
            (ngSubmit)="onVerifySignup(vform)" class="form create-account" novalidate>
            <div class="form-group p-relative text-center text-xl-start" [hidden]="verificationExceeded">


              <div class="row">
                <div class="col-12 col-md-12 col-xl mt-2">
                  <input formControlName="verificationCode" type="text" class="form-control code-verify"
                    placeholder="{{ 'sign_up.verification_code_placeholder' | translate }}" tabindex="2" />
                </div>
                <div class="col-12 col-md-12 col-xl-auto text-center mt-2 mt-xl-0">
                  <app-primary-button [text]="'sign_up.verify_btn' | translate" [loading]="verifyingCodeInProgress"
                    type="submit" [fullWidth]="true">
                  </app-primary-button>
                </div>
              </div>

              <div [hidden]="verifySignupFG.controls['verificationCode'].valid || !vform.submitted"
                class="alert alert-danger">
                <span [hidden]="!verifySignupFG.controls.verificationCode.errors?.required">{{
                  'sign_up.verification_error' | translate
                  }}</span>
              </div>
            </div>
            <div class="form-errors alert alert-danger" [hidden]="!verifySignupErrors || !verifySignupErrors.length">
              <ul>
                <li class="text-center" *ngFor="let error of verifySignupErrors">
                  {{ error }}
                </li>
              </ul>
            </div>
          </form>
          <div class="clearfix content-footer" [hidden]="successfulMsg">
            <h2 class="global-title">{{ translate.currentLang === 'en' ? 'If you can\'t complete this process, please contact the CAL administrator.' : 'যদি আপনি এই প্রক্রিয়াটি সম্পূর্ণ করতে না পারেন, অনুগ্রহ করে CAL প্রশাসকের সাথে যোগাযোগ করুন।' }}</h2>
            <p class="global-subheading">{{ translate.currentLang === 'en' ? 'Please fill out the details, and our support team will assist you shortly.' : 'অনুগ্রহ করে বিবরণ পূরণ করুন, এবং আমাদের সহায়তা দল শীঘ্রই আপনাকে সহায়তা করবে।' }}
            </p>
            <div class="w-100 text-center">
              <button type="button" class="w-100 m-t text-center global-blue-button"
                [loading]="contactAdministratorInProgress" (click)="contactAdmin()">
                {{ translate.currentLang === 'en' ? 'Contact Administrator' : 'প্রশাসকের সাথে যোগাযোগ করুন' }}
              </button>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="reset-pw" [hidden]="!resetPassword">
    <form class="form user-form v-row" #pwform="ngForm" [formGroup]="passwordResetFG" (ngSubmit)="passwordReset(pwform)"
      novalidate>
      <span class="col"></span>
      <div class="inner-fields">
        <h3>{{ translate.currentLang === 'en' ? 'Reset Password' : 'পাসওয়ার্ড রিসেট করুন' }}</h3>
        <div class="item-fields">
          <div class="form-group m-t-xl">
            <div class="form-group">
              <label class="hidden-label">{{ translate.currentLang === 'en' ? 'New Password' : 'নতুন পাসওয়ার্ড' }}</label>
              <input formControlName="password" type="password" class="form-control" [placeholder]="translate.currentLang === 'en' ? 'Your Password' : 'আপনার পাসওয়ার্ড'"
                tabindex="1" />
              <div class="description">
                {{ translate.currentLang === 'en' ? 'Password must be at least 8 characters in length containing at least one upper case, one numeric and one special character' : 'পাসওয়ার্ড অবশ্যই কমপক্ষে 8 অক্ষরের হতে হবে যাতে কমপক্ষে একটি বড় হাতের অক্ষর, একটি সংখ্যা এবং একটি বিশেষ অক্ষর থাকে' }}
              </div>
              <div [hidden]="passwordResetFG.controls['password'].valid">
                <span [hidden]="
                    !passwordResetFG.controls.password.errors?.required || (!pwform.submitted && !passwordResetFG.controls.password.touched)
                  " class="alert alert-danger">{{ translate.currentLang === 'en' ? 'Required' : 'আবশ্যক' }}</span>
                <span [hidden]="!passwordResetFG.controls.password.errors?.password" class="alert alert-danger">{{
                  passwordResetFG.controls['password'].errors?.password
                  }}</span>
              </div>
            </div>
            <div class="form-group">
              <label class="hidden-label">{{ translate.currentLang === 'en' ? 'Confirm Password' : 'পাসওয়ার্ড নিশ্চিত করুন' }}</label>
              <input formControlName="confirmPassword" type="password" class="form-control"
                [placeholder]="translate.currentLang === 'en' ? 'Retype New Password' : 'নতুন পাসওয়ার্ড পুনরায় টাইপ করুন'" tabindex="2" />
              <div
                *ngIf="passwordResetFG.controls['confirmPassword'].invalid && passwordResetFG.controls['confirmPassword'].touched"
                class="alert alert-danger">
                <span [hidden]="!passwordResetFG.controls.confirmPassword.errors?.required">{{ translate.currentLang === 'en' ? 'Please re-type your password.' : 'অনুগ্রহ করে আপনার পাসওয়ার্ড পুনরায় টাইপ করুন।' }}</span>
              </div>
              <div *ngIf="passwordResetFG.errors" class="alert alert-danger">
                <span [hidden]="!passwordResetFG.errors?.misMatchPasswords">{{ translate.currentLang === 'en' ? 'Passwords don\'t match.' : 'পাসওয়ার্ড মিলছে না।' }}</span>
              </div>
            </div>
            <!-- <div class="form-group m-t m-b-sm">
              <div class="recaptchaSlide">
                <custom-captcha [control]="passwordResetFG.get('captchaText')" placeholder="Type the text" label="Enter CAPTCHA text shown in the image"
                  [showErrors]="pwform.submitted" (captchaRequest)="captchaRequest($event)" [resetOnError]="resetOnError">
                  <span [hidden]="!passwordResetFG.get('captchaText').errors?.required">The CAPTCHA field is required</span>
                </custom-captcha>
              </div>
            </div> -->

            <div class="form-group clearfix">
              <app-primary-button [text]="translate.currentLang === 'en' ? 'Submit' : 'জমা দিন'" [loading]="passwordResetInProgress" type="submit" [fullWidth]="true">
              </app-primary-button>
            </div>
            <errors style="position: relative; top: 10px" [on]="passwordResetErrors">
              {{ passwordResetErrors }}
            </errors>
          </div>
        </div>
      </div>
    </form>
  </div>

  <div class="success-msg" *ngIf="successfulMsg">
    <div class="inner-fields">
      <h3>{{ translate.currentLang === 'en' ? 'Successfully Submitted' : 'সফলভাবে জমা দেওয়া হয়েছে' }}</h3>

      <p>{{ translate.currentLang === 'en' ? 'Your details have been successfully submitted!' : 'আপনার বিবরণ সফলভাবে জমা দেওয়া হয়েছে!' }}</p>
      <p>{{ translate.currentLang === 'en' ? 'CAL will contact you shortly regarding your password.' : 'CAL শীঘ্রই আপনার পাসওয়ার্ড সম্পর্কে আপনার সাথে যোগাযোগ করবে।' }}</p>

      <div class="button-row">
        <button type="button" class="global-blue-button" (click)="goToLogin()">
          {{ translate.currentLang === 'en' ? 'Done' : 'সম্পন্ন' }}
        </button>
      </div>
    </div>
  </div>
</div>